import { useQuery } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'
import { useParams } from 'react-router-dom'
import { IMission } from 'utils/interfaces'
import { MissionId, toMissionId } from 'utils/types'

const useMission = (id?: number | MissionId) => {
  const params = useParams()
  const rawParamId = Number(params.missionId)
  const missionId = id !== undefined ? toMissionId(id as number) : (isNaN(rawParamId) ? undefined : toMissionId(rawParamId))

  return useQuery<IMission, Error>({
    queryKey: ['mission', missionId],
    queryFn: () => {
      if (!missionId) return Promise.reject(new Error('Mission ID is required'))
      return MainApi.fetchMission(missionId)
    },
    staleTime: 1000 * 60 * 3,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    enabled: !!missionId,
  })
}
export default useMission
